import React from 'react';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import DAYS from './../../data/Days';
import ONDE_TREINA from './../../data/Onde_treina';
import TEMPO_MUSCULACAO from './../../data/TempoMusculacao';
import TIPOS_PLANILHA from './../../data/TiposPlanilha';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';

const URL= WS.paginas.termos;

export default class PageTermos extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false
    };
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: URL,
      data:{ htmldb: 1 },
      sucess:function(data){
        var msg;
        _self.setState({
          page: data,
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }


  render() {
    const view = this.state.loaded ? null : this.state.page;
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html: view}}>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/perfil/PageTermos.js